import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import logBehaviorMixin from 'next/javascripts/mixins/log-behavior-mixin';
import { closest } from 'next/javascripts/modules/dom';
import 'next/stylesheets/components/teams/trial-plans.scss';

Component('tr-team-trial-plans', {
  properties: {
    isOnboarding: Boolean,
  },

  mixins: [eventListenerMixin, logBehaviorMixin],

  connected() {
    this.listenTo(this, 'click', this.handleSelectPlanClick.bind(this));
  },

  handleSelectPlanClick(event) {
    const selectButton = closest(event.target, '.select-plan-button');
    if (selectButton) {
      [...this.querySelectorAll('.select-plan-button')].forEach((button) => {
        if (button !== selectButton) button.setAttribute('disabled', '');
      });

      if (!this.isOnboarding) return;
      const plan = selectButton.dataset.params ? selectButton.dataset.params.split('=')[1] : 'free';
      this.sendLogBehavior({
        resourceType: 'OnboardingGuide',
        resourceId: 6,
        behaviorAction: 'next',
        extraValues: {
          stage: 'select_plan',
          plan,
        },
      });
    }
  },
});
